<template>
  <component :is="wrapper || 'div'" v-bind="props">
    <div class="options-filter">
      <zaproo-checkbox
        v-for="option of filter?.options"
        :key="option.value"
        :model-value="option.selected"
        :name="`option-${option.value}`"
        class="categories-filter-item py-2 pl-4 pr-3"
        @update:model-value="toggleOption(option.value)"
      >
        <span class="mr-1 text-base font-normal text-zinc-900">{{
          option.name
        }}</span>
        <span class="text-base font-normal text-zinc-500"
          >({{ option.count }})</span
        >
      </zaproo-checkbox>
    </div>
  </component>
</template>
<script lang="ts" setup>
import type { KlevuFilterResultOptions } from "@klevu/core";
import { type Component } from "vue";
import type { FilterManagerFilterOptions } from "~/modules/catalog/classes/FilterManager/FilterManagerFilterOptions";
import type { IFilterManager } from "~/modules/catalog/classes/IFilterManager";

const props = defineProps<{
  wrapper?: Component;
  filter: KlevuFilterResultOptions | FilterManagerFilterOptions;
  filterManager: IFilterManager;
}>();

const emit = defineEmits<{
  (_event: "filterChanged", _param: any): void;
}>();

function toggleOption(optionValue: string): void {
  props.filterManager.toggleOption(props.filter.key, optionValue);
  emit("filterChanged", props.filter);
}
</script>
<style lang="scss">
.options-filter {
}
</style>
